export default Object.freeze({
  ENTER_SEARCH_WORD: '검색어를 입력하세요.',
  FAIL_TO_GET_BOARD_INFO: '게시글 정보를 가져오는데 실패하였습니다.',
  SELECT_ARTICLE: '게시글을 선택해 주세요.',
  CONFIRM_DELETE_ARTICLE: '선택한 게시글을 삭제하시겠습니까? 삭제한 게시글은 복원되지 않습니다.',
  COMPLETE_DELETE: '게시글이 삭제되었습니다.',
  MULTI_SELECT: '하나의 게시글만 선택해 주세요.',
  REPLY_PERMISSION: '답글 등록이 불가한 게시글입니다.',
  FAIL_TO_FETCH_DATA: '데이터가 존재하지 않습니다.',
  REPLY_DEPTH: '답글의 답글은 작성할 수 없습니다.',

  TITLE: '게시글 관리',
  FORM_ONE: '쇼핑몰 선택',
  BTN_SEARCH: '조회',
  BTN_RESET: '초기화',
  FORM_TWO: '게시판',
  FORM_THREE: '게시판 카테고리',
  FORM_FOUR: '검색어',
  SEARCH_TYPE_ALL: '전체',
  SEARCH_TYPE_TITLE: '제목',
  SEARCH_TYPE_CONTENT: '내용',
  SEARCH_TYPE_WRITER: '작성자',
  PLACEHOLDER: '검색어 입력',
  NOTICE: '공지',
  FORM_FIVE: '작성일시',
  TABLE_TITLE: '조회결과',
  BTN_DELETE: '게시글 삭제',
  BTN_MOVE: '게시글 이동',
  BTN_ADD: '신규 게시글 등록',
  BTN_ADD_REPLY: '답글 등록',

  HEADER_MALLNAME: '쇼핑몰',
  HEADER_NO: '게시글 번호',
  HEADER_BOARD: '게시판',
  HEADER_CATEGORY_NO: '게시판 카테고리',
  HEADER_TITLE: '제목',
  HEADER_OPENED: '공개여부',
  HEADER_REPLY_COUNT: '답글수',
  HEADER_SECRETED: '비밀글',
  HEADER_READ_COUNT: '조회수',
  HEADER_WRITER: '작성자',
  HEADER_CREATION_DATE_TIME: '작성일시',
  HEADER_EDITOR: '최종수정자',
  HEADER_MODIFICATION_DATE_TIME: '최종수정일시',
  HEADER_PARENT_BOARD_ARTICLE: '답글여부',

  ARTICLE_EXCEL_DOWNLOAD: '게시글 엑셀 다운로드',
  ALL_EXCEL_DOWNLOAD: '전체 엑셀 다운로드',
  REPLY_SEARCH: '답글 조회',
  CATEGORY_ALL: '게시판 카테고리 전체',
  NEW_ARTICLE: '게시글 신규 작성',
  ADD_REPLY: '답글 작성',
  MODIFY_ARTICLE: '게시글 수정',
});
